import { useMemo } from "react";

import type { Profile } from "@/core/types";

import type { Accomplishments } from "../types";
import {
  buildPatientAccomplishmentMilestones,
  buildPatientAccomplishmentSessions,
} from "../components/Widget/AccomplishmentsWidget";
import { useActivityList } from "../api/queries/useActivityList";

export function usePatientAccomplishments(profile: Profile | undefined): Nullable<Accomplishments> {
  const { data: scheduledSessions } = useActivityList({ isEnabled: !!profile, type: "schedule" });

  return useMemo<Nullable<Accomplishments>>(() => {
    if (!profile || !scheduledSessions) return null;

    return {
      memberMilestoneActivities: buildPatientAccomplishmentMilestones(profile),
      memberSessionActivities: buildPatientAccomplishmentSessions(scheduledSessions),
    };
  }, [profile, scheduledSessions]);
}
